module.exports = __webpack_public_path__ + "f1aa9c56b39f3924943c95e4e63a09f9.pdf";